import React, { useState, createContext, useCallback, useEffect } from "react";

import { TState, TContext } from "./types";

const initialState: TState = {
    recipients: [],
    lastUsedBank: undefined,
};

export const SyncContext = createContext({} as TContext);

export const SyncProvider = ({ children }: { children: React.ReactNode }) => {
    const [syncState, setSyncState] = useState<TState>(initialState);
    const [lastSource, setLastSource] = useState<"LOCAL" | "REMOTE">("LOCAL");

    useEffect(() => {
        console.log("[syncState]", syncState);
    }, [syncState]);

    const resetSyncState = useCallback(() => {
        setSyncState(initialState);
    }, []);

    const updateSyncState = useCallback(
        (args: Partial<TState>, source: "LOCAL" | "REMOTE") => {
            setLastSource(source);
            setSyncState((prevState) => ({ ...prevState, ...args }));
        },
        []
    );

    return (
        <SyncContext.Provider
            value={{
                syncState,
                lastSource,
                resetSyncState,
                updateSyncState,
            }}
        >
            {children}
        </SyncContext.Provider>
    );
};
